import { ReactNode } from "react";

import { DesignType, PlatformType, Workflow } from "./design";
import { GeneType } from "./common";

export enum CatalogFilterType {
  ASSAY = "assay",
  DISEASE = "disease",
  PLATFORM = "platform",
  DESIGN = "design",
}

export interface ICatalogSearchTerm {
  type: GeneType;
  name: string; // It's name of gene symbol or gene alias
}

export interface ITypeFilterOption {
  id: number;
  label: string | ReactNode;
  type?: Workflow | PlatformType | DesignType;
  selected?: boolean;
  disabled?: boolean;
}

export interface ITypeFilter {
  type: CatalogFilterType;
  label: string;
  expanded: boolean;
  options: Array<ITypeFilterOption>;
}
